import { create } from 'zustand';

export const useUserTourStore = create((set) => ({
  run: false,
  stepIndex: 0,
  steps: [],
  tourActive: false,

  startTour: (steps) =>
    set({
      run: true,
      steps,
      tourActive: true,
      stepIndex: 0,
    }),

  scheduleTour: () =>
    set({
      tourActive: true,
      run: false,
      stepIndex: 0,
    }),

  stopTour: () =>
    set({
      run: false,
      tourActive: false,
      stepIndex: 0,
    }),

  setRun: (runState) => set({ run: runState }),

  nextStep: () =>
    set((state) => ({
      stepIndex: state.stepIndex + 1,
    })),

  setStepIndex: (index) =>
    set({
      stepIndex: index,
    }),

  resetTour: () =>
    set({
      run: false,
      stepIndex: 0,
      steps: [],
      tourActive: false,
    }),
}));
